import { fmt } from "../lib/api";

const dayLabel = (d) => new Date(`${d}T00:00:00Z`).toLocaleDateString(undefined, { weekday: "short", month: "short", day: "numeric", timeZone: "UTC" });

function Chip({ b, planName }) {
  const color = b.tier === 2 ? "#A78BFA" : "#F59E0B";
  const tip = `${b.name} · ${fmt(b.qty)} units${b.minutes ? ` · ${(b.minutes / 60).toFixed(1)} h` : ""}${b.reason === "plan" ? ` · Production Plan${planName ? `: ${planName}` : ""}` : b.reason === "demand" ? " · inventory demand" : ""}${b.late ? " · LATE vs need-by date" : ""}${b.completed ? " · DONE" : ""}`;
  return (
    <div data-tip={tip} data-testid={`h90-batch-${b.id}`}
      className={`truncate text-[10px] font-mono px-1 rounded-sm ${b.reason === "plan" ? "border-l-2 border-[#10B981]" : ""} ${b.late ? "ring-1 ring-[#EF4444]" : ""} ${b.completed ? "opacity-50 line-through" : ""}`}
      style={{ background: `${color}22`, color }}>{fmt(b.qty)}× {b.sku}</div>
  );
}

function Cell({ d, dues, planNames }) {
  const pct = d.capacity_minutes ? (d.scheduled_minutes / d.capacity_minutes) * 100 : d.scheduled_minutes ? 999 : 0;
  const bar = pct > 100 ? "bg-[#EF4444]" : pct >= 90 ? "bg-[#F59E0B]" : "bg-[#10B981]";
  return (
    <div data-testid={`h90-day-${d.date}`} className={`p-1.5 rounded-md border bg-[#0F1623] min-h-[96px] overflow-hidden flex flex-col ${d.week1 ? "border-[#F59E0B]/60" : "border-[#1E293B]"} ${!d.workday && !d.batches.length ? "opacity-40" : ""}`}>
      <div className="flex items-center justify-between font-mono text-[10px] text-[#6B7280]"><span>{dayLabel(d.date)}</span>{d.week1 && <span className="text-[#F59E0B] font-bold">W1</span>}</div>
      {d.workday && <div className="h-1 mt-1 bg-[#172033] rounded-sm overflow-hidden" data-tip={`${(d.scheduled_minutes / 60).toFixed(1)} / ${(d.capacity_minutes / 60).toFixed(1)} h`}><div className={`h-full ${bar}`} style={{ width: `${Math.min(100, pct)}%` }} /></div>}
      <div className="space-y-0.5 mt-1">
        {dues.map((p) => <div key={p.plan_id} data-testid={`h90-due-${p.plan_id}`} data-tip={`Plan due: ${fmt(p.qty)} × ${p.name}`} className={`truncate text-[10px] font-mono font-bold px-1 rounded-sm ${p.status === "expired" ? "bg-[#EF4444]/20 text-[#EF4444]" : "bg-[#10B981]/20 text-[#10B981]"}`}>DUE {p.name}</div>)}
        {d.batches.map((b) => <Chip key={b.id} b={b} planName={planNames[b.plan_id]} />)}
      </div>
    </div>
  );
}

export default function NinetyDayGrid({ data }) {
  const days = data.days;
  const planNames = Object.fromEntries(data.plans.map((p) => [p.plan_id, p.name]));
  const blocks = [days.slice(0, 30), days.slice(30, 60), days.slice(60, 90)].filter((b) => b.length);
  return (
    <div className="space-y-8" data-testid="h90-grid">
      {blocks.map((b, bi) => (
        <div key={bi} data-testid={`h90-block-${bi}`}>
          <div className="font-mono text-[10px] tracking-[0.2em] text-[#6B7280] mb-2">DAYS {bi * 30 + 1}–{bi * 30 + b.length} · {b[0].date} → {b[b.length - 1].date}</div>
          <div className="grid gap-1.5 grid-cols-2 sm:grid-cols-5 lg:grid-cols-7 xl:grid-cols-10">
            {b.map((d) => <Cell key={d.date} d={d} dues={data.plans.filter((p) => p.target_date === d.date)} planNames={planNames} />)}
          </div>
        </div>
      ))}
    </div>
  );
}
